import React, { useEffect, useState } from "react";
import { ExportState } from "../models/ProjectMetadata";
import { useEtsConversionStatus } from "./useEtsConversionStatus.ts";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import { etsEventEmitter } from "../etsFunctions/etsWebSocket";
import { isSyncActive } from "../etsFunctions/etsFunctions";

export function EtsConversionStatusOverlay() {
  useEtsConversionStatus();
  useOnChangeWatcher(state.projectMetadata);

  const exportState = state.projectMetadata.exportState;
  if (exportState === ExportState.None) return null;

  let iconClass = "";
  let color = "var(--knxColorBlack)";

  switch (exportState) {
    case ExportState.WaitingForUploadReady:
      iconClass = "las la-upload rising-icon"; // no itx
      color = "orange"; // no itx
      break;
    case ExportState.WaitingForConversion:
    case ExportState.ConversionIsRunning:
      iconClass = "las la-cog la-spin"; // no itx
      color = "dodgerblue"; // no itx
      break;
    case ExportState.WaitingForDownload:
      iconClass = "las la-check-circle"; // no itx
      color = "limegreen"; // no itx
      break;
    case ExportState.Failure:
      iconClass = "las la-exclamation-circle"; // no itx
      color = "red"; // no itx
      break;
  }

  return (
    <i
      className={`menuStatusIcon ${iconClass}`}
      style={{
        position: "absolute", // no itx
        bottom: "-4px", // no itx
        right: "-4px", // no itx
        fontSize: "14px", // no itx
        color, // no itx
        backgroundColor: "white", // no itx
        borderRadius: "50%", // no itx
      }}
    ></i>
  );
}

export function EtsPushStatusOverlay() {
  const [pushActive, setPushActive] = useState(isSyncActive());

  useEffect(() => {
    const handleSyncProgressChange = (active: boolean) => {
      setPushActive(Boolean(active));
    };

    etsEventEmitter.on("syncProgressChange", handleSyncProgressChange); // no itx
    setPushActive(isSyncActive());
    return () => {
      etsEventEmitter.off("syncProgressChange", handleSyncProgressChange); // no itx
    };
  }, []);

  if (!pushActive) return null;

  return (
    <i
      className="menuStatusIcon las la-sync la-spin"
      title="Push to ETS is running"
      style={{
        position: "absolute", // no itx
        top: "-4px", // no itx
        right: "-4px", // no itx
        fontSize: "14px", // no itx
        color: "orange", // no itx
        backgroundColor: "white", // no itx
        borderRadius: "50%", // no itx
      }}
    ></i>
  );
}
